<div
	class="dropdown"
	data-test="global-pipeline-dropdown"
	(jepClickOutside)="onClickedOutside()"
>
	<mat-spinner
		*ngIf="isLoading"
		[diameter]="28"
		class="spinner-center spinner"
		data-test="mat-spinner"
	></mat-spinner>
	<div *ngIf="!isLoading">
		<a
			class="dropdown__selected"
			data-test="create-pipeline"
			*ngIf="
				pipelinesUnderAccount.length === 0 && !noResults;
				else selectedPipelineName
			"
			(click)="createPipeline()"
		>
			<jep-avatar
				[icon]="'icon-plus'"
				[src]="null"
				[name]="null"
				[theme]="'dark'"
				class="avatar"
				style="display: inline-block; vertical-align: middle"
			></jep-avatar>
			<span class="dropdown__selected-text">Create a pipeline</span>
		</a>
		<ng-template #selectedPipelineName>
			<div class="dropdown__selected">
				<a (click)="toggleDropdownBoxState($event)">
					<jep-avatar
						[name]="
							selectedPipeline?.title
						"
						[src]="selectedPipeline?.logo"
						theme="light"
						class="avatar"
						[isLogo]="true"
					></jep-avatar>
					<span class="dropdown__selected-text">{{
						selectedPipeline?.title
					}}</span>
					<span
						class="icon-chevron-down"
						style="display: inline-block; vertical-align: middle"
					></span>
				</a>
			</div>
		</ng-template>
		<div
			class="dropdown__box"
			[@dropdownBoxState]="dropdownBoxState"
			style="width: 640px"
		>
			<div
				class="dropdown__search-box"
				[ngStyle]="{
					display:
						dropdownListHeight < 272 &&
						searchText != '' &&
						searchText?.length <= 0
							? 'none'
							: 'block',
				}"
			>
				<span class="icon-search"></span>
				<input
					#search
					(ngModelChange)="onSearch($event)"
					[(ngModel)]="searchText"
					placeholder="Search"
				/>
			</div>
			<ul #dropdownPipelines class="dropdown__list">
				<ng-scrollbar
					[autoUpdate]="true"
					*ngIf="dropdownListHeight >= 272; else noScrollOrNoResults"
				>
					<li
						class="dropdown__item"
						*ngFor="let pipeline of pipelinesUnderAccount"
						data-test="pipeline-dropdown-item"
					>
						<a
							class="dropdown__link"
							mat-button
							(click)="selectPipeline(pipeline)"
						>
							<jep-avatar
								[name]="
									pipeline?.title
								"
								[src]="pipeline?.logo"
								size="small"
								theme="light"
								isLogoListing="true"
							></jep-avatar>
							<span class="pipeline-name">{{
								pipeline?.title
							}}</span>
						</a>
					</li>
				</ng-scrollbar>
				<ng-template #noScrollOrNoResults>
					<ng-container *ngIf="!noResults">
						<li
							class="dropdown__item"
							*ngFor="let pipeline of pipelinesUnderAccount"
							data-test="pipeline-dropdown-item"
						>
							<a
								class="dropdown__link"
								mat-button
								(click)="selectPipeline(pipeline)"
							>
								<jep-avatar
									[name]="
										
											pipeline?.title
										
									"
									[src]="
										pipeline?.logo
									"
									size="small"
									theme="light"
									isLogoListing="true"
								></jep-avatar>
								<span class="pipeline-name">{{
									pipeline?.title
								}}</span>
							</a>
						</li>
					</ng-container>
					<ng-container *ngIf="noResults">
						<li class="dropdown__item">
							<span class="dropdown__label"
								>Sorry, no results found.</span
							>
						</li>
					</ng-container>
				</ng-template>
			</ul>
			<ul class="dropdown__nav">
				<li>
					<a
						class="dropdown__add-new"
						(click)="createNewPipeline()"
						mat-button
						data-test="add-new-pipeline"
					>
						<span class="icon-plus"></span>
						<span>New Pipeline</span>
					</a>
				</li>
			</ul>
		</div>
	</div>
</div>
